<script setup>
defineProps({
  noPadding: { type: Boolean, default: false },
});
</script>

<template>
  <div class="page-body" :class="{ 'no-padding': noPadding }">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/layout";

.page-body {
  padding: layout.$content-pad;
  flex: 1;
  min-width: 0;
  min-height: 0;
}

.page-body.no-padding {
  padding: 0;
}
</style>
